export abstract class UserSettings {
    protected settings: string[];

    public constructor(userSettingsString: string, settingsCount = 5) {
        this.settings = userSettingsString.split(";")

        if (this.settings.length !== settingsCount) {
            throw new Error(`Invalid usersettingsstring (length ${this.settings.length} should be ${settingsCount})`);
        }
    }

    public get SessieId() {
        return this.settings[0];
    }

    public get DatabaseAlias() {
        return this.settings[1];
    }

    public get LoginUrl() {
        return this.settings[2];
    }

    public get AdminID() {
        return this.settings[3];
    }

    public get UserID() {
        return this.settings[4];
    }
}
